var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_621_938)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4112 18.3057L15.4235 20.0448L9.30649 30.6399L7.55078 26.7242L12.4112 18.3057Z",
    fill: "#418ED6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4106 18.3056L9.39827 16.5664L3.28125 27.1615L7.55014 26.7241L12.4106 18.3056Z",
    fill: "#2B63A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7076 18.3057L13.6953 20.0448L19.8123 30.6399L21.568 26.7242L16.7076 18.3057Z",
    fill: "#2B63A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.707 18.3056L19.7193 16.5664L25.8363 27.1615L21.5674 26.7241L16.707 18.3056Z",
    fill: "#418ED6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5544 21.3813C20.282 21.3813 24.9252 16.7381 24.9252 11.0105C24.9252 5.28282 20.282 0.639648 14.5544 0.639648C8.82676 0.639648 4.18359 5.28282 4.18359 11.0105C4.18359 16.7381 8.82676 21.3813 14.5544 21.3813Z",
    fill: "url(#paint0_linear_621_938)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5563 19.1057C19.0272 19.1057 22.6516 15.4813 22.6516 11.0104C22.6516 6.53944 19.0272 2.91504 14.5563 2.91504C10.0853 2.91504 6.46094 6.53944 6.46094 11.0104C6.46094 15.4813 10.0853 19.1057 14.5563 19.1057Z",
    fill: "#595959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_621_938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 3,
    width: 18,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9853 19.9891C19.4666 19.9891 23.0994 16.3562 23.0994 11.8749C23.0994 7.39358 19.4666 3.76074 14.9853 3.76074C10.5039 3.76074 6.87109 7.39358 6.87109 11.8749C6.87109 16.3562 10.5039 19.9891 14.9853 19.9891Z",
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_621_938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5517 19.1248C19.033 19.1248 22.6658 15.492 22.6658 11.0106C22.6658 6.52932 19.033 2.89648 14.5517 2.89648C10.0703 2.89648 6.4375 6.52932 6.4375 11.0106C6.4375 15.492 10.0703 19.1248 14.5517 19.1248Z",
    fill: "url(#paint1_linear_621_938)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5987 5.36523L16.349 8.86592L19.8497 9.30349L17.4459 11.9991L18.0994 15.8673L14.5987 14.117L11.098 15.8673L11.7573 11.9991L9.34766 9.30349L12.8484 8.86592L14.5987 5.36523Z",
    fill: "#8B8B8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_621_938",
    x1: 14.5544,
    y1: 0.639648,
    x2: 14.5544,
    y2: 21.3813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D7D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_621_938",
    x1: 14.5517,
    y1: 2.89649,
    x2: 14.5517,
    y2: 19.1248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCFCF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_621_938"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.639648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/Silver.f50a880429d30d17c5273a3b25299c61.svg";
export { ForwardRef as ReactComponent };